import { render, staticRenderFns } from "./newExchange.vue?vue&type=template&id=f6a16b90&scoped=true&"
import script from "./newExchange.vue?vue&type=script&lang=js&"
export * from "./newExchange.vue?vue&type=script&lang=js&"
import style0 from "./newExchange.vue?vue&type=style&index=0&id=f6a16b90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a16b90",
  null
  
)

export default component.exports